import { DASHBOARD_QUERY_ROOT_KEY } from "@/core/constants/dashboard.constants";
import type {
    DashboardCacheVersions,
    DashboardScope,
    DashboardWidgetName,
} from "@/core/interfaces/Dashboard";

export function buildDashboardQueryKey(
  widget: DashboardWidgetName,
  scope: DashboardScope | null,
  filters: Record<string, unknown> = {},
  cacheVersion: string | number | null = null
): unknown[] {
  return [
    DASHBOARD_QUERY_ROOT_KEY,
    widget,
    scope?.type ?? null,
    scope?.idDonVi ?? null,
    scope?.idKho ?? null,
    scope?.provinceCode ?? null,
    scope?.fromDate ?? null,
    scope?.toDate ?? null,
    filters,
    cacheVersion,
  ];
}

export function getVersionTokenForWidget(
  widget: DashboardWidgetName,
  versions: DashboardCacheVersions,
  scope: DashboardScope | null
): string {
  const parts: string[] = [];

  if (versions.global != null) {
    parts.push(`global:v${versions.global}`);
  }

  if (scope?.idDonVi != null && versions.unit != null) {
    parts.push(`unit:${scope.idDonVi}:v${versions.unit}`);
  }

  if (scope?.idKho != null && versions.warehouse != null) {
    parts.push(`warehouse:${scope.idKho}:v${versions.warehouse}`);
  }

  if (widget === "summary" || widget === "system-summary") {
    if (versions.summary != null) {
      parts.push(`summary:v${versions.summary}`);
    }
  }

  if (widget === "inventory-movement" && versions.movement != null) {
    parts.push(`movement:v${versions.movement}`);
  }

  if (widget === "ticket-statuses" && versions.tickets != null) {
    parts.push(`tickets:v${versions.tickets}`);
  }

  if (widget === "alerts" && versions.alerts != null) {
    parts.push(`alerts:v${versions.alerts}`);
  }

  if (widget === "top-entities" && versions.topEntities != null) {
    parts.push(`top_entities:v${versions.topEntities}`);
  }

  if (widget === "map" && versions.map != null) {
    parts.push(`map:v${versions.map}`);
  }

  if (widget === "recent-activities" && versions.activities != null) {
    parts.push(`activities:v${versions.activities}`);
  }

  parts.push(`widget:${widget}`);

  return parts.join(":");
}
